/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "368")


  
    
export type API48434Item = {};
    
  



  export type API48434Req = {};



export interface API48434Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** String  */
  data?: string[];
  /**   */
  exceptionMsg?: string;
  
};


// 48434 查询OKR负责人列表

export interface IUseGetAPI48434Return {
  /** 查询OKR负责人列表: 接口请求状态 */
  isAPI48434Loading: boolean;
  /** 查询OKR负责人列表: 接口请求返回数据 */
  dataAPI48434: API48434Res;
  /**  查询OKR负责人列表: 接口数据请求方法 */
  fetchAPI48434Data:  ( config?: YWRequestConfig) => Promise<API48434Res>;
  /** 查询OKR负责人列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI48434 = ():IUseGetAPI48434Return => {
  let isMount = true;
  const [isAPI48434Loading, setIsAPI48434Loading] = useState(false);
  const [dataAPI48434, setDataAPI48434] = useState<API48434Res>({} as API48434Res);
  const requestUrl = `${basePath}/internal-control-biz/project/okr/leader/list`;

  const fetchAPI48434Data = async ( config?: YWRequestConfig): Promise<API48434Res> => {
  
    if ( isMount ) {
      setIsAPI48434Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48434Res>(`${basePath}/internal-control-biz/project/okr/leader/list`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48434(res || {} as API48434Res);
        setIsAPI48434Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48434Loading(false);
      }
      return false as unknown as API48434Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48434Loading,
    dataAPI48434,
    fetchAPI48434Data,
    requestUrl,
  }
}

